/* Install as a deferred theme asset on every storefront page. See docs/referrals.md. */
(() => {
  const storageKey = 'capra_referral_campaigns';
  const uuid = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i;
  const now = Date.now();
  function isActive(referral) {
    return referral && typeof referral === 'object'
      && typeof referral.visit === 'string' && uuid.test(referral.visit)
      && Number.isInteger(referral.year) && referral.year >= 1000 && referral.year <= 9999
      && Number.isFinite(referral.expiresAt) && referral.expiresAt > now;
  }
  let saved;
  let referrals = [];
  try {
    saved = localStorage.getItem(storageKey);
    const parsed = JSON.parse(saved);
    if (Array.isArray(parsed)) referrals = parsed.filter(isActive);
  } catch { /* An incoming link still works when storage is unavailable. */ }

  const url = new URL(window.location.href);
  const year = url.searchParams.get('capra_referral_year');
  const incoming = {
    visit: url.searchParams.get('capra_referral'),
    year: year && /^[1-9]\d{3}$/.test(year) ? Number(year) : NaN,
    expiresAt: Date.parse(url.searchParams.get('capra_referral_expires') || ''),
  };
  let referral = referrals.at(-1);
  let legacyKey;
  if (isActive(incoming)) {
    referral = referrals.find(value => value.year === incoming.year);
    if (!referral) {
      // Older assets stored only the visit UUID. A valid incoming link now
      // supplies the missing campaign metadata while preserving that first visit.
      legacyKey = `capra_referral_${incoming.year}`;
      let legacyVisit;
      try { legacyVisit = localStorage.getItem(legacyKey); } catch { /* Use this link. */ }
      referral = { ...incoming, visit: legacyVisit && uuid.test(legacyVisit) ? legacyVisit : incoming.visit };
    }
  }
  if (referral) {
    referral = { ...referral, visit: referral.visit.toLowerCase() };
    // Keep the first visit for each active campaign, and remember which
    // campaign was most recently selected for subsequent storefront pages.
    referrals = referrals.filter(value => value.year !== referral.year).concat(referral);
  }
  try {
    if (referrals.length) {
      const serialized = JSON.stringify(referrals);
      if (serialized !== saved) localStorage.setItem(storageKey, serialized);
      if (legacyKey) localStorage.removeItem(legacyKey);
    } else if (saved !== null && saved !== undefined) localStorage.removeItem(storageKey);
  } catch { /* Cart and form attributes still work on the current page. */ }
  if (!referral) return;
  const visit = referral.visit;
  const root = window.Shopify?.routes?.root || '/';
  let syncing;
  function syncCart() {
    if (!syncing) {
      syncing = fetch(`${root}cart/update.js`, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { capra_referral: visit } }),
      }).then(response => {
        if (!response.ok) throw new Error('Referral cart update failed');
        return response.json();
      }).finally(() => { syncing = null; });
    }
    return syncing;
  }
  function addProperty(form) {
    if (!/\/cart\/add(?:\.js)?$/.test(new URL(form.action, location.href).pathname)) return;
    let input = form.querySelector('input[name="properties[_capra_referral]"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden'; input.name = 'properties[_capra_referral]'; form.append(input);
    }
    input.value = visit;
  }
  function prepareForms() { document.querySelectorAll('form[action]').forEach(addProperty); }
  // Express product checkout can skip cart attributes. Referred buyers use
  // the normal cart checkout, which is fenced on a successful attribute save.
  const style = document.createElement('style');
  style.textContent = '.shopify-payment-button,shopify-accelerated-checkout,shopify-accelerated-checkout-cart{display:none!important}';
  document.head.append(style);
  function showError() {
    let error = document.getElementById('capra-referral-error');
    if (!error) {
      error = document.createElement('p'); error.id = 'capra-referral-error'; error.setAttribute('role', 'alert');
      document.body.prepend(error);
    }
    error.textContent = "We couldn't save your referral. Please try checkout again.";
    error.scrollIntoView({ block: 'nearest' });
  }
  const permittedSubmissions = new WeakSet();
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    addProperty(form);
    if (permittedSubmissions.has(form)) { permittedSubmissions.delete(form); return; }
    const submitter = event.submitter;
    const path = new URL(submitter?.getAttribute('formaction') || form.action, location.href).pathname;
    if (submitter?.getAttribute('name') !== 'checkout' && !/\/checkout\/?$/.test(path)) return;
    event.preventDefault(); event.stopImmediatePropagation();
    syncCart().then(() => {
      permittedSubmissions.add(form);
      form.requestSubmit(submitter || undefined);
    }).catch(showError);
  }, true);
  document.addEventListener('click', event => {
    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!link || !/\/checkout\/?$/.test(new URL(link.href, location.href).pathname)) return;
    event.preventDefault(); event.stopImmediatePropagation();
    syncCart().then(() => { location.assign(link.href); }).catch(showError);
  }, true);
  prepareForms();
  // Cart drawers and quick-add forms are often rendered after page load.
  new MutationObserver(prepareForms).observe(document.documentElement, { childList: true, subtree: true });
  void syncCart().catch(() => { /* Checkout retries and shows an actionable error. */ });
})();
